export const HERO_SLIDE_SHELL =
  "hero-slide-shell relative flex h-[380px] w-full flex-col overflow-hidden rounded-3xl border border-zinc-200/50 bg-zinc-50 shadow-[0_24px_64px_-28px_rgba(0,0,0,0.12)] dark:border-white/[0.05] dark:bg-[#0c0d10] dark:shadow-[0_24px_64px_-28px_rgba(0,0,0,0.85)] sm:h-[400px]";

export const HERO_SLIDE_SHELL_OVERFLOW =
  "hero-slide-shell relative flex h-[380px] w-full overflow-hidden rounded-3xl border border-zinc-200/50 bg-zinc-50 shadow-[0_24px_64px_-28px_rgba(0,0,0,0.12)] dark:border-white/[0.05] dark:bg-[#0c0d10] dark:shadow-[0_24px_64px_-28px_rgba(0,0,0,0.85)] sm:h-[400px]";

export const HERO_SLIDE_BACKDROP =
  "pointer-events-none absolute inset-0 overflow-hidden rounded-3xl";

export const HERO_SLIDE_GLOW =
  "absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(255,197,57,0.14),transparent_55%)] dark:bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(255,197,57,0.09),transparent_55%)]";

export const HERO_SLIDE_GLOW_ROSE =
  "absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(251,113,133,0.16),transparent_55%)] dark:bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(251,113,133,0.12),transparent_55%)]";

export const HERO_SLIDE_TOP_SHINE =
  "absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-zinc-300/60 to-transparent dark:via-white/10";

export const HERO_SLIDE_HEADER_BORDER =
  "border-b border-zinc-200/50 dark:border-white/[0.05]";
export const HERO_SLIDE_ROW_BORDER =
  "border-b border-zinc-200/45 dark:border-white/[0.05]";
export const HERO_SLIDE_DIVIDER_STRONG =
  "border-t border-zinc-200/50 dark:border-white/[0.05]";
export const HERO_SLIDE_DIVIDER =
  "divide-y divide-zinc-200/45 dark:divide-white/[0.05]";
export const HERO_SLIDE_PANEL_BORDER =
  "border-zinc-200/50 dark:border-white/[0.05]";

export const HERO_SLIDE_LABEL =
  "text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400 dark:text-white/40";

export const HERO_SLIDE_LABEL_SM =
  "text-[9px] font-semibold uppercase tracking-[0.18em] text-zinc-400 dark:text-white/35";

export const HERO_SLIDE_MUTED = "text-zinc-500 dark:text-white/55";
export const HERO_SLIDE_SUBTLE = "text-zinc-400 dark:text-white/40";
export const HERO_SLIDE_SUBTLE_SM =
  "text-[9px] text-zinc-400 dark:text-white/40";
export const HERO_SLIDE_BODY = "text-sm text-zinc-600 dark:text-white/70";
export const HERO_SLIDE_ACCENT_TEXT = "text-zinc-800 dark:text-white/90";
export const HERO_SLIDE_CHARACTER =
  "text-center text-[10px] font-semibold uppercase tracking-[0.22em] text-zinc-400 dark:text-white/50";

export const HERO_SLIDE_CHIP =
  "rounded-full border border-zinc-200/50 bg-zinc-100 px-2.5 py-1 text-[10px] font-medium text-zinc-500 dark:border-white/[0.05] dark:bg-white/[0.04] dark:text-white/55";

export const HERO_SLIDE_CHIP_INACTIVE =
  "rounded-full border border-zinc-200/50 bg-zinc-100 px-2 py-0.5 text-[10px] font-medium text-zinc-500 dark:border-white/[0.05] dark:bg-white/[0.04] dark:text-white/45";

export const HERO_SLIDE_POPOVER =
  "pointer-events-none absolute z-20 rounded-2xl border border-zinc-200/50 bg-white shadow-[0_24px_64px_-12px_rgba(0,0,0,0.12)] backdrop-blur dark:border-gray/30 dark:bg-[#191B1F] dark:shadow-[0_24px_64px_-12px_rgba(0,0,0,0.7)]";

export const HERO_SLIDE_POPOVER_TITLE =
  "text-[11px] font-semibold tracking-tight text-zinc-700 dark:text-white/85";
export const HERO_SLIDE_POPOVER_BODY =
  "text-[11px] leading-snug text-zinc-500 dark:text-white/65";
export const HERO_SLIDE_POPOVER_META =
  "text-[10px] text-zinc-400 dark:text-white/45";
export const HERO_SLIDE_POPOVER_DIVIDER =
  "border-b border-zinc-200/50 dark:border-white/5";

export const HERO_SLIDE_SKELETON_BAR =
  "rounded-full bg-zinc-200/90 dark:bg-white/[0.07]";
export const HERO_SLIDE_SKELETON_BAR_SOFT =
  "rounded-full bg-zinc-200/70 dark:bg-white/[0.06]";
export const HERO_SLIDE_SKELETON_BAR_FAINT =
  "rounded-full bg-zinc-200/60 dark:bg-white/[0.05]";

export const HERO_SLIDE_AVATAR_RING =
  "ring-1 ring-zinc-200/90 dark:ring-white/[0.06]";
export const HERO_SLIDE_AVATAR_TEXT =
  "text-[10px] font-semibold text-zinc-700 dark:text-white/90";

export const HERO_SLIDE_WORK_PANEL = "bg-white dark:bg-[#14161A]";
export const HERO_SLIDE_TIMELINE_PANEL = "bg-zinc-50 dark:bg-[#12141A]";

export const HERO_SLIDE_DIFF_UNCHANGED =
  "rounded-lg px-2.5 py-2 text-[11px] leading-snug text-zinc-500 dark:text-white/45";
export const HERO_SLIDE_DIFF_CHANGED =
  "rounded-lg border border-amber/20 bg-amber/5 px-2.5 py-2 text-[11px] leading-snug text-zinc-600 dark:text-white/70";

export const HERO_SLIDE_SHOOT_DAY =
  "text-[10px] font-semibold text-zinc-800 dark:text-white/90";
export const HERO_SLIDE_BANNER =
  "pl-4 text-[10px] italic text-zinc-400 dark:text-white/50";
export const HERO_SLIDE_WORK_ROW =
  "pl-4 text-[10px] text-zinc-600 dark:text-white/70";

export type HeroSlideRoadmapBarVariant = "shoot_day" | "int" | "ext";

/** Literal classes here so Tailwind always emits roadmap bar colors (matches product stripboard). */
export const HERO_SLIDE_ROADMAP_BAR_TONES: Record<
  HeroSlideRoadmapBarVariant,
  string
> = {
  shoot_day: "bg-amber text-black",
  int: "bg-sky-500/85 text-white",
  ext: "bg-emerald-500/85 text-white",
};
